import { writable } from 'svelte/store';

export const isHeaderMenuOpen = writable(false);

export const openHeaderMenu = (): void => {
  isHeaderMenuOpen.set(true);
};

export const closeHeaderMenu = (): void => {
  isHeaderMenuOpen.set(false);
};

export const headerMenuBinding = writable(true);
export const siteNoticeBinding = writable(true);
export const siteNoticeShow = writable(false);
